import React from 'react'
import Home from './components/Home'
import SignUp from './components/Sign-up'
import Login from './components/Login'
import { Switch, Route } from 'react-router-dom'
import EventMaker from './components/EventMaker'
import PrivateRoute from './components/PrivateRoute'
import styled from 'styled-components'
import EventEdit from './components/eventEdit'


const StyledApp = styled.div`
    background-color: #242943;
    text-align: center;
    h1, h2 {
        color: white;
    }
`




function App(){
    return(
        <StyledApp>
            <div>
             <h1>Plan Your Potluck!</h1>
            <h2>The one stop shop to make your potluck one to remember</h2>
            </div>

            <Switch>
                <Route path='/potluck'>
                    <EventMaker />
                </Route>
            <PrivateRoute exact path="/home" component={Home} />
                {/* <Route path='/home'> */}
                    {/* <Home /> */}
                {/* </Route> */}
                <Route path='/sign-up'>
                    <SignUp />
                </Route>
                <Route exact path='/'>
                    <Login />
                </Route>
                <Route exact path = '/eventEdit/:id'>
                    <EventEdit/>
                </Route>
            </Switch>
        </StyledApp>
    )
}

export default App